import * as Filter from '../components/filterGroup';

export function InitNoticeTabPage() {
    Filter.Init();
}
